module.exports = __webpack_public_path__ + "img/3M.211c2028.png";